import React, { useState, useRef, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMessage,
  faXmark,
  faPaperPlane,
  faUser,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

import "./ChatWidth.css";
import WoSenderOwl from "../../../images/wo-Sender.gif";
import WoSenderBanner from "../../../images/LandingPageImage/wosender.svg";
import { basicauth } from "../../../utils/Crediantials";
const WS_URL = "wss://blogapi.bumppy.com/ws/admin-chat";

const ChatBotHome = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [view, setView] = useState("list");
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [UserClient, setUserClient] = useState("");
  const [verificationMethod, setVerificationMethod] = useState("email");

  const socketRef = useRef(null);
  const messagesEndRef = useRef(null);

  const { username, password } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const connectWebSocket = () => {
    if (socketRef.current) return;
    const socket = new WebSocket(WS_URL);
    socketRef.current = socket;

    socket.onmessage = (event) => {
      const msg = JSON.parse(event.data);
      if (msg.type === "NEW_CHAT") {
        setMessages((prev) => [
          ...prev,
          {
            id: Date.now(),
            message: msg.data.lastMessage,
            type: msg.data.type === "SENT" ? "SENT" : "RECEIVED",
            datetime: msg.data.time,
          },
        ]);
      }
    };
  };

  useEffect(() => {
    if (view === "chatHistory") connectWebSocket();
  }, [view]);

  const SendText = async () => {
    if (!newMessage.trim()) return;

    await fetch("https://blogapi.bumppy.com/api/Support/sendSupportChatUser", {
      method: "POST",
      headers: {
        Authorization: `Basic ${base64Credentials}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        mobile: UserClient,
        message: newMessage,
      }),
    });

    setNewMessage("");
  };

  const handleNewChat = async (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const mobile = formData.get("phone");

    setUserClient(mobile);
    setView("chatHistory");

    await fetch(
      "https://blogapi.bumppy.com/api/Support/submitChatUserDetails",
      {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userName: formData.get("name"),
          userEmail: formData.get("email"),
          userMobile: mobile,
        }),
      },
    );
  };

  const handleVerification = (e) => {
    e.preventDefault();
    const mobile = new FormData(e.target).get("verification");
    setUserClient(mobile);
    setView("chatHistory");
  };

  return (
    <div className="custom_chat_container">
      <button
        className={`custom_chat_button ${isOpen ? "hidden-btn" : ""}`}
        onClick={() => setIsOpen(true)}
      >
        <img src={WoSenderOwl} alt="chat" className="chatbot_owl_image" />
      </button>

      {isOpen && (
        <div className="custom_chat_widget">
          {/* HEADER */}
          <div className="ws-chat-header">
            <div className="ws-header-left">
              <h1>
                Hello <span className="wave">👋</span>
              </h1>
              <h2>Welcome to WoSender</h2>
               <p className="custom_header_subtitle changing-text">
                Need help with <p className="word "></p> ?
              </p>
            </div>

            <div className="ws-header-right">
              <FontAwesomeIcon
                icon={faXmark}
                className="ws-close-icon"
                onClick={() => setIsOpen(false)}
              />
            </div>
          </div>

          {/* BODY */}
          <div className="ws-chat-body">
            {view === "list" && (
              <>
                <div className="ws-banner-card">
                  <img
                    className="ws-banner-img"
                    src={WoSenderBanner}
                    alt="WoSender"
                  />
                </div>

                <div
                  className="custom_chat_card"
                  onClick={() => setView("verifyUser")}
                >
                  <div className="custom_card_header">
                    <div className="custom_card_info">
                      <div className="custom_avatar custom_avatar_continue">
                        <FontAwesomeIcon icon={faUser} />
                      </div>

                      <div className="custom_card_text">
                        <h5 className="custom_card_title">
                          Continue Conversation
                        </h5>
                        <p className="custom_card_subtitle">
                          View your chat history
                        </p>
                      </div>
                    </div>

                    <FontAwesomeIcon icon={faChevronRight} />
                  </div>
                </div>

                <div
                  className="custom_chat_card"
                  onClick={() => setView("newChat")}
                >
                  <div className="custom_card_header">
                    <div className="custom_card_info">
                      <div className="custom_avatar chat-blue">
                        <FontAwesomeIcon icon={faMessage} />
                      </div>

                      <div className="custom_card_text">
                        <h5 className="custom_card_title">Start New Chat</h5>
                        <p className="custom_card_subtitle">
                          Get help from our team
                        </p>
                      </div>
                    </div>

                    <FontAwesomeIcon icon={faChevronRight} />
                  </div>
                </div>

                <div className="chat-footer-text">
                  — Welcome to WoSender Support
                </div>
              </>
            )}

            {view === "verifyUser" && (
              <form onSubmit={handleVerification} className="chat-form-modern">
                <div className="toggle-tabs">
                  <button
                    type="button"
                    className={
                      verificationMethod === "email" ? "tab active" : "tab"
                    }
                    onClick={() => setVerificationMethod("email")}
                  >
                    Email
                  </button>

                  <button
                    type="button"
                    className={
                      verificationMethod === "mobile" ? "tab active" : "tab"
                    }
                    onClick={() => setVerificationMethod("mobile")}
                  >
                    Mobile
                  </button>
                </div>

                <label className="modern-label">
                  Enter your{" "}
                  {verificationMethod === "email" ? "Email" : "Mobile Number"}
                </label>

                <input
                  className="modern-input"
                  name="verification"
                  required
                  placeholder={
                    verificationMethod === "email"
                      ? "your@email.com"
                      : "1234567890"
                  }
                />

                <button className="modern-primary-btn">Continue Chat</button>

                <button
                  type="button"
                  className="modern-secondary-btn"
                  onClick={() => setView("list")}
                >
                  Back to Menu
                </button>
              </form>
            )}

            {view === "newChat" && (
              <form onSubmit={handleNewChat} className="chat-form-modern">
                <label className="modern-label">Name</label>
                <input
                  className="modern-input"
                  name="name"
                  required
                  placeholder="Jhonny Bravo"
                />

                <label className="modern-label">Email</label>
                <input
                  className="modern-input"
                  name="email"
                  required
                  placeholder="BravoJhonny@example.com"
                />

                <label className="modern-label">Phone</label>
                <input
                  className="modern-input"
                  name="phone"
                  required
                  placeholder="911xxxxx"
                />

                <button className="modern-primary-btn">Start Chat</button>

                <button
                  type="button"
                  className="modern-secondary-btn"
                  onClick={() => setView("list")}
                >
                  Back to Menu
                </button>
              </form>
            )}

            {view === "chatHistory" && (
              <div className="messages">
                {messages.map((m) => (
                  <div
                    key={m.id}
                    className={`bubble ${
                      m.type === "SENT" ? "chat-sent" : "chat-received"
                    }`}
                  >
                    <div>{m.message}</div>
                    <span className="custom_message_time">{m.datetime}</span>
                  </div>
                ))}
                <div ref={messagesEndRef} />
              </div>
            )}
          </div>

          {/* INPUT */}
          {view === "chatHistory" && (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                SendText();
              }}
              className="chat-input"
            >
              <input
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                placeholder="Type your message..."
              />
              <button>
                <FontAwesomeIcon icon={faPaperPlane} />
              </button>
            </form>
          )}
        </div>
      )}
    </div>
  );
};

export default ChatBotHome;
